
import AuthStore from '@vue3/store/auth-store'
import CommonStore from '@vue3/store/common-store.js'
import { mapState } from 'pinia'
import tracker from '@vue3/constants/tracker'

const { origin_screen } = tracker

export default {
  computed: {
    ...mapState(AuthStore, ['isLoggedIn', 'getDealerId']),
    ...mapState(CommonStore, ['registrationId']),
    $windowDataLayer () {
      return window.dataLayer || []
    },
    $pageType () {
      if (this.$route && this.$route.name) {
        return origin_screen[this.$route.name] || ''
      }
      return ''
    },
    $trackerRegistrationId () {
      if (!this.isLoggedIn) {
        return 'LOGGED_OUT_USER'
      }
      return this.registrationId
    },
    $trackerDealerId () {
      if (!this.isLoggedIn) {
        return 'LOGGED_OUT_USER'
      }
      if (!this.getDealerId) {
        return 'LOGGED_IN_WITHOUT_DEALER_ID'
      }
      return this.getDealerId
    }
  },
  methods: {
    $trackButtonClick (componentName, payload) {
      this.$pushCustomTracker('button_click', componentName, payload)
    },
    $trackPageImpression ({ componentName, payload }) {
      this.$pushCustomTracker('page_impression', componentName, payload)
    },
    $trackError (componentName, payload) {
      this.$pushCustomTracker('track_error', componentName, payload)
    },
    $trackSectionView (componentName, payload) {
      this.$pushCustomTracker('section_view', componentName, payload)
    },
    $trackViewItemList (componentName, payload, ecommerce) {
      this.$pushEcommerceTracker('view_item_list', componentName, payload, ecommerce)
    },
    $trackAddToCart (componentName, payload, ecommerce) {
      this.$pushEcommerceTracker('add_to_cart', componentName, payload, ecommerce)
    },
    $trackRemoveFromCart (componentName, payload, ecommerce) {
      this.$pushEcommerceTracker('remove_from_cart', componentName, payload, ecommerce)
    },
    $trackBeginCheckout (componentName, payload, ecommerce) {
      this.$pushEcommerceTracker('begin_checkout', componentName, payload, ecommerce)
    },
    $pushCustomTracker (eventName, componentName = null, payload = {}) {
      const trackerData = {
        event: eventName,
        params: {
          origin_screen: this.$pageType,
          user_id: this.$trackerRegistrationId,
          dealer_id: this.$trackerDealerId,
          component: componentName,
          ...payload
        }
      }
      this.$pushClearTracker()
      this.$windowDataLayer.push(trackerData)
    },
    $pushEcommerceTracker (eventName, componentName = null, payload = {}, ecommerce = {}) {
      const trackerData = {
        event: eventName,
        params: {
          origin_screen: this.$pageType,
          user_id: this.$trackerRegistrationId,
          component: componentName,
          event_category: 'Ecommerce',
          cart_category: 'Retail',
          ...payload
        },
        ecommerce: {
          currency: 'IDR',
          ...ecommerce
        }
      }
      this.$pushClearTracker()
      this.$windowDataLayer.push(trackerData)
    },
    $pushClearTracker () {
      this.$windowDataLayer.push({ params: null, ecommerce: null })
    }
  }
}
